import config from '@/config/index';
/**
 * configManager 配置管理器
 * 实现共享配置与子项目配置的自动合并与覆盖。
 * 用法示例：
 *   import configManager from '../config/configManager';
 *   const payConfig = configManager.get('pay');
 *
 * 子项目只需在自身 config/index.js 中定义同名配置即可覆盖共享配置。
 */

// 默认共享配置（可根据实际情况扩展）
const defaultConfig = {
  BASE_API: '/api',
  SIGN_KEY: 'yskey.key',
  ALIPAY_WAP: 'Alipay_AopWap',
  ALIPAY_APP: 'Alipay_AopApp',
  ALIPAY_JS: 'Alipay_AopJs',
  WECHATPAY_WAP: 'WechatPay_Mweb',
  WECHATPAY_APP: 'WechatPay_App',
  WECHATPAY_JS_PUBLIC: 'WechatPay_Public',
  WECHATPAY_JS_PROGRAM: 'WechatPay_Program'
};

// 子项目配置
const projectConfig = config || {};

/**
 * 配置管理器单例
 * 提供 get 方法获取合并后的配置
 */
const configManager = {
  /**
   * 获取指定模块的配置
   * @param {string} key 配置模块名，如 'pay'
   * @returns {Object} 合并后的配置对象
   * 示例：configManager.get('pay')
   */
  get(key) {
    const merged = {
      ...defaultConfig,
      ...projectConfig
    }[key];
    return merged;
  },
  /**
   * 获取全部合并后的配置
   * @returns {Object} 合并后的完整配置对象
   * 示例：configManager.getAll()
   */
  getAll() {
    return mergeDeep(defaultConfig, projectConfig);
  }
};

export default configManager;
